import { createAction } from '@reduxjs/toolkit';
import type { PlacesSearch } from './mapSettingsPlaces.state';

export const mapSettingsPlacesAddSearch = createAction(
  'MAP_SETTINGS_PLACES_ADD_SEARCH',
  ({ newSearch, zoomTo }: {newSearch: PlacesSearch; zoomTo?: boolean}) => ({
    payload: { newSearch, zoomTo },
  })
);

export const mapSettingsPlacesRemoveSearch = createAction(
  'MAP_SETTINGS_PLACES_REMOVE_SEARCH',
  (search: PlacesSearch) => ({ // we want the search object passed for easier future undo implementation
    payload: { search },
  })
);
